// extracted by mini-css-extract-plugin
export default {"wrapper":"TruckOfferingTooltip_wrapper_y6fWM","container":"TruckOfferingTooltip_container_VAS7v","closeIcon":"TruckOfferingTooltip_closeIcon_g_jx6"};